import { render, staticRenderFns } from "./addDictionary.vue?vue&type=template&id=bd478ad6&scoped=true"
import script from "./addDictionary.vue?vue&type=script&lang=js"
export * from "./addDictionary.vue?vue&type=script&lang=js"
import style0 from "./addDictionary.vue?vue&type=style&index=0&id=bd478ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd478ad6",
  null
  
)

export default component.exports